import { render, staticRenderFns } from "./BMEdit.vue?vue&type=template&id=0ce41a0b"
import script from "./BMEdit.vue?vue&type=script&lang=js"
export * from "./BMEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports